import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import { useMemo } from 'react'
import { routes } from '../../../../../../constants/routes'
import { Link } from 'react-router-dom'

export default function useBreadcrumbItems(stampNumber?: string): BreadcrumbItemType[] {
    return useMemo(() => {
        return [
            {
                key: routes.home,
                title: <Link to={routes.home}>Дашборд</Link>,
            },
            {
                key: routes.equipment,
                title: <Link to={routes.equipment}>Оборудование</Link>,
            },
            {
                key: routes.equipmentStamps,
                title: <Link to={routes.equipmentStamps}>Штампы</Link>,
            },
            {
                key: routes.equipmentStamp,
                title: stampNumber ? `Штамп № ${stampNumber}` : 'Новый штамп',
            },
        ]
    }, [stampNumber])
}
